/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profiledraft1Inputs */

const en_profiledraft1 = /** @type {(inputs: Profiledraft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

const de_profiledraft1 = /** @type {(inputs: Profiledraft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf`)
};

/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Profiledraft1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profiledraft1 = /** @type {((inputs?: Profiledraft1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profiledraft1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profiledraft1(inputs)
	return de_profiledraft1(inputs)
});
export { profiledraft1 as "profileDraft" }